module.exports = __webpack_public_path__ + "static/media/github-logo.59454f80.svg";